/**
 * soundPrefs — cache partagé des préférences « Son des notifications »
 * (GET /settings/notif-sound-prefs). Utilisé par la cloche ET par les
 * composants AVI temps réel pour un réglage centralisé (spec iter269).
 */
import api from "@/lib/api";

let _prefs = { enabled: true, values: {} };
let _loaded = false;
let _inflight = null;

export function resolveSoundKey(type) {
  if (!type) return type;
  if (type.startsWith("avi_decision_") || type.startsWith("avi_final_")) return "avi_decision";
  if (type === "avi_info_reminder_creator") return "avi_reminder";
  return type;
}

export async function loadSoundPrefs(force = false) {
  if (_loaded && !force) return _prefs;
  if (_inflight) return _inflight;
  _inflight = api.get("/settings/notif-sound-prefs")
    .then(({ data }) => {
      _prefs = { enabled: !!data.enabled, values: data.values || {} };
      _loaded = true;
      return _prefs;
    })
    .catch(() => _prefs)
    .finally(() => { _inflight = null; });
  return _inflight;
}

export function setSoundPrefs(prefs) {
  _prefs = { enabled: !!prefs.enabled, values: prefs.values || {} };
  _loaded = true;
}

export function isSoundAllowed(typeOrKey) {
  if (!_loaded) loadSoundPrefs();
  if (!_prefs.enabled) return false;
  const key = resolveSoundKey(typeOrKey);
  return _prefs.values[key] === true;
}
